//style files
import "./index.scss";

const TimelineSection = () => {
  return (
    <section
      id="timeline-section"
      className="w-full flex justify-center bg-[url(../../assets/images/timelinebg.png)] bg-cover bg-center overflow-hidden"
    >
      <div className="w-4/5 max-w-screen-xl pt-28 space-y-10">
        <div>
          <h4 className="text-white text-5xl sm:text-7xl font-bold">Süreç</h4>
        </div>
        <div className="w-full space-y-0">
          <div className="flex flex-col lg:flex-row w-full justify-around">
            <div
              data-aos={window.innerWidth < 1023 ? "fade-up" : "fade-left"}
              className="lg:w-1/4 whitespace-nowrap border-l-2 lg:border-l-0 pl-9 lg:pl-0 border-b-0 lg:border-b-2 pb-10 relative flex flex-col lg:items-center"
            >
              <div className="space-y-2">
                <h4 className="text-3xl text-white font-extrabold">
                  Başvuru <br /> Süreci
                </h4>
                <p className="text-xl text-white font-medium">
                  27 Aralık 2022 <br />
                  29 Ocak 2023
                </p>
              </div>
              <div
                className="hidden lg:block w-5 h-5 rounded-full bg-white absolute bottom-0 left-1/2 "
                style={{ bottom: "-10px" }}
              />
              <div
                className="lg:hidden block w-5 h-5 rounded-full bg-white absolute left-0 top-1/3 "
                style={{ left: "-10px" }}
              />
            </div>
            <div
              data-aos={window.innerWidth < 1023 ? "fade-up" : "fade-left"}
              className="lg:w-1/4 whitespace-nowrap border-l-2 lg:border-l-0 pl-9 lg:pl-0 border-b-0 lg:border-b-2 pb-10 relative flex flex-col lg:items-center"
            >
              <div className="space-y-2">
                <h4 className="text-3xl text-white font-extrabold">
                  Değerlendirme <br /> Süreci
                </h4>
                <p className="text-xl text-white font-medium">
                  Ocak - Şubat 2023
                </p>
              </div>
              <div
                className="hidden lg:block w-5 h-5 rounded-full bg-white absolute bottom-0 left-1/2 "
                style={{ bottom: "-10px" }}
              />
              <div
                className="lg:hidden block w-5 h-5 rounded-full bg-white absolute left-0 top-1/3 "
                style={{ left: "-10px" }}
              />
            </div>
            <div
              data-aos={window.innerWidth < 1023 ? "fade-up" : "fade-left"}
              className="lg:w-1/4 whitespace-nowrap border-l-2 lg:border-l-0 pl-9 lg:pl-0 border-b-0 lg:border-b-2 pb-10 relative flex flex-col lg:items-center"
            >
              <div className="space-y-2">
                <h4 className="text-3xl text-white font-extrabold">Teklif</h4>
                <p className="text-xl text-white font-medium">
                  30 Ocak <br />1 Şubat 2023
                </p>
              </div>
              <div
                className="hidden lg:block w-5 h-5 rounded-full bg-white absolute bottom-0 left-1/2 "
                style={{ bottom: "-10px" }}
              />
              <div
                className="lg:hidden block w-5 h-5 rounded-full bg-white absolute left-0 top-1/3 "
                style={{ left: "-10px" }}
              />
            </div>
            <div
              data-aos={window.innerWidth < 1023 ? "fade-up" : "fade-left"}
              className="lg:w-1/4 whitespace-nowrap border-l-2 lg:border-l-0 pl-9 lg:pl-0 border-b-0 lg:border-b-2 pb-10 relative flex flex-col lg:items-center"
            >
              <div className="space-y-2">
                <h4 className="text-3xl text-white font-extrabold">
                  Başlangıç
                </h4>
                <p className="text-xl text-white font-medium">6 Şubat 2023</p>
              </div>
              <div
                className="hidden lg:block w-5 h-5 rounded-full bg-white absolute bottom-0 left-1/2 "
                style={{ bottom: "-10px" }}
              />
              <div
                className="lg:hidden block w-5 h-5 rounded-full bg-white absolute left-0 top-1/3 "
                style={{ left: "-10px" }}
              />
            </div>
          </div>
          <div className="w-full flex justify-center relative h-20 md:h-36">
            <h4 className="slogan text-4xl sm:text-6xl md:text-8xl lg:text-9xl text-white italic font-extrabold whitespace-nowrap tracking-normal absolute">
              GELECEĞİN RAY’INDA
            </h4>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TimelineSection;
